import { atom } from "recoil";

export const selectedThoughtRecordKeyAtom = atom<string | undefined>({
  key: "selectedThoughtRecordKey",
  default: undefined,
});